<template>
  <Head :title="title" />

  <div class="bg-gray-100 text-sm min-h-screen">
    <div class="md:flex md:items-stretch md:flex-col">
      <div class="md:h-screen min-h-full md:flex md:flex-col">
        <top-bar :class="{ 'fixed top-0 w-full z-20': $page.props.settings.sidebar == 'mini' }" @on-mobile-menu-change="v => (show = v)" />
        <div class="md:flex md:flex-grow md:items-stretch" :class="$page.props.settings.sidebar != 'mini' ? 'overflow-hidden' : 'pt'">
          <mini-main-menu v-if="$page.props.settings.sidebar == 'mini'" class="hidden md:grid" />
          <full-main-menu v-else class="hidden md:grid" />
          <transition name="slide-fade">
            <full-main-menu v-if="show" class="block md:hidden" />
          </transition>
          <div class="md:flex-1 md:px-4 py-6 md:p-4 md:overflow-y-auto" scroll-region>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
  <flash-messages></flash-messages>
</template>

<script>
import TopBar from '@/Shared/Top/Navbar';
import { Head } from '@inertiajs/inertia-vue3';
import FlashMessages from '@/Shared/FlashMessages';
import FullMainMenu from '@/Shared/Sidebar/FullMainMenu';
import MiniMainMenu from '@/Shared/Sidebar/MiniMainMenu';

export default {
  props: ['title'],

  components: {
    Head,
    TopBar,
    FullMainMenu,
    MiniMainMenu,
    FlashMessages,
  },

  data() {
    return { show: false };
  },
};
</script>
